import axios, { AxiosInstance } from "axios";
import { notification } from "antd";

const axiosInstance: AxiosInstance = axios.create({
  baseURL: "https://coprodux-server-latest-ft90.onrender.com/",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("coprodux-token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status } = error.response;

      if (status === 401 || status === 403) {
        localStorage.clear();

        window.location.href = "/";
        notification.error({
          message: "Não Autorizado",
          description: "Você não está autorizado a acessar este recurso.",
        });
      }
    } else if (error.request) {
      notification.error({
        message: "Erro de Rede",
        description:
          "Falha ao enviar a requisição. Verifique sua conexão de rede.",
      });
    } else {
      notification.error({
        message: "Erro",
        description: error.message.message || "Ocorreu um erro.",
      });
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
